import { createAction, props } from '@ngrx/store';
import { ISearchRequest } from '../Authentication/auth.models';

export enum ActionTypes {
  GET_CONTACT_QUERIES = '[Contact Queries] Get Contact Queries',
  GET_CONTACT_QUERIES_SUCCESS = '[Contact Queries] Get Contact Queries Success',
  GET_CONTACT_QUERIES_FAILURE = '[Contact Queries] Get Contact Queries Failure',
}

export const getContactQueries = createAction(
  ActionTypes.GET_CONTACT_QUERIES,
  props<{ data: ISearchRequest }>()
);

export const getContactQueriesSuccess = createAction(
  ActionTypes.GET_CONTACT_QUERIES_SUCCESS,
  props<{ data: any }>()
);

export const getContactQueriesFailure = createAction(
  ActionTypes.GET_CONTACT_QUERIES_FAILURE,
  props<{ error: any }>()
);
